<!--
  @description 文章列表组件
  @author hefeng
-->
<template>
  <div class="model-article-list">
    <el-main v-if="articleList.length != 0">
      <el-card
        v-for="list in articleList"
        :key="list.id"
        shadow="hover"
        class=""
        :body-style="{padding: '15px'}"
      >
        <router-link target="_blank" :to="'/article/detail/'+list.id" class="clear overflow-hidden article-list">
          <div class="art-image">
            <div class="img-box" style="width:200px;height:150px;background-color: #f4f4f4;"
            :style="{'background-image':'url(' + $commonFunc.imageFormat(list.articleImgurl, 1) + ')'}">
            </div>
          </div>
          <div class="art-des ml-3 pt-2">
            <h5 class="h-article-color-green text-truncate f-w500 font16 m-0">{{list.title}}</h5>
            <p class="art-summary-info">{{ list.digest }}</p>
            <span class="">{{list.createDate | day}}</span>
          </div>
        </router-link>
      </el-card>
      <div></div>
      <Pagination @parentMethod="pageChange" :total="total" :pageSize="pageSize" :currentPage="pageNum"></Pagination>
    </el-main>
    <div v-else class="text-center mt-3">{{ noData ? '暂无数据' : '加载中...'}}</div>
  </div>
</template>

<script>
// 导入分页组件
import Pagination from "@/components/Pagination.vue";

export default {
  name: "ArticleList",
  components: {
    Pagination
  },
  data() {
    return {
      articleList: [],
      total: 0,
      pageNum: 1,
      pageSize: 6,
      currentPage: 1,
      keyword: "",
      noData: false,
    };
  },
  computed: {
    categoryId() {
      return this.$route.params.id;
    },
    isCategory() {
      return this.categoryId !== "all";
    }
  },
  watch: {
    $route: "getArticleList"
  },
  created() {
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      let url = "";
      this.noData = false;
      if(this.isCategory) {
        url = "/protal/article/articleCategory/" + this.categoryId + "?ran=" + Math.random();
      }else {
        url = "/protal/article/list" + "?ran=" + Math.random();
      }
      let params = {
        pageNum: this.pageNum,
        pagesize: this.pageSize,
      }
      this.axios
        .get(url, {params})
        .then(res => {
          if(res.data.code == 200){
            let data = res.data.data || {};
            this.articleList = data.articleList;
            this.total = data.total;
          } else {
            this.articleList = [];
          }
          this.noData = true;
        })
        .catch(err => console.error(err));
    },
    // 
    pageChange(page) {
      this.pageNum = page;
      this.getArticleList();
    }
  }
};
</script>

<style lang="scss" scoped>
  .model-article-list {
    width: 100%;
  }
  .el-main {
    padding: 0 8px 80px 30px;
    .el-card {
      margin-bottom: 25px;
      border: 1px solid #fff;
      // &:hover {
      //   border-color: #333;
      // }
      .article-list {
        // display:flex;
        height: 150px;
        color: #898d7e;
        .art-image {
          width: 200px;
          float: left;
        }
        .art-des {
          width: calc(100% - 14px - 200px);
          float: left;
        }
        .art-summary-info {
          line-height: 22px;
          height: 90px;
          margin-bottom: 0px;
        }
        .el-icon-view{
          font-size: 16px;
        }
      }
    }
  }
  .search-article {
    padding: 0 8px 0 45px;
  }
</style>
